/**
 * @fileOverview This file contains the implementation of the location edit modal for Inventory module
 * @version 1.0.0
 * @since 1.0.0
 * @author Diego Benitez Reyna
 */

import { Autocomplete, TextField } from '@mui/material';
import customAxios from '../../../utils/customAxios';
import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import 'react-toastify/dist/ReactToastify.css';

import '../../../scss/Components/_modal.scss';
import { GlobalVariables } from '../../../globalVar';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { getToast } from '../../../utils/toastConfig';
import { trimValue } from '../../../utils/generalUtils';

const ModalULocation = ({ data, show, onHide, refreshData }) => {
  const { editString, saveStr } = useTranslationHook();

  const [rack, setRack] = useState(data.rack);
  const [inventoryTypeId, setInventoryTypeId] = useState(
    data.inventory_type_id
  );
  const [inventoryTypeName, setInventoryTypeName] = useState(
    data.inventory_type_name
  );

  const [inventoryTypeList, setInventoryTypeList] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimedRack = trimValue(rack);

    try {
      const editRes = await customAxios.patch(
        `${GlobalVariables.getURL()}locations/update/${data.id}`,
        {
          rack: trimedRack,
          inventory_type_id: inventoryTypeId,
        },
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        }
      );

      getToast({
        status: editRes.data.status,
        title: editRes.data.message,
      });

      handleClose();
    } catch (error) {
      console.log(error);
      if (error.response.data?.errors) {
        const errors = error.response.data?.errors;
        errors.forEach((err) => {
          getToast({ status: 'error', title: err.message });
        });
      } else {
        getToast({
          status: error.response.data.status,
          title: error.response.data.message,
        });
      }
    }
  };

  const getInventoryTypeList = async () => {
    try {
      const { data: res } = await customAxios.get(
        `${GlobalVariables.getURL()}inventory/getInventoryTypesList`,
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        }
      );
      setInventoryTypeList(res.data);
    } catch (error) {
      console.log(error);
      setInventoryTypeList([]);
    }
  };

  useEffect(() => {
    if (!show) return;

    getInventoryTypeList();
  }, [show]);

  const handleClose = () => {
    resetFields();
    refreshData();
    onHide();
  };

  const resetFields = () => {
    setRack('');
    setInventoryTypeId('');
    setInventoryTypeName('');
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      backdropClassName='modal-backdrop'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          {`${editString} Ubicación`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id='inventory-form' onSubmit={handleSubmit}>
          <div className='row'>
            <div className='col-md-12'>
              <TextField
                sx={{ width: '100%' }}
                label='Nombre'
                type='text'
                value={rack || ''}
                onChange={(e) => setRack(e.target.value)}
                required
              />
            </div>
          </div>

          <br />

          <div className='row'>
            <div className='col-md-12'>
              <Autocomplete
                disablePortal
                includeInputInList={false}
                options={inventoryTypeList}
                value={
                  inventoryTypeId
                    ? {
                        id: inventoryTypeId,
                        name: inventoryTypeName,
                      }
                    : { id: '', name: '' }
                }
                sx={{ width: '100%' }}
                getOptionLabel={(inventoryTypeList) => inventoryTypeList.name}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Seleccionar almacén...'
                    inputProps={{
                      ...params.inputProps,
                    }}
                    required={true}
                  />
                )}
                onChange={async (e, value) => {
                  setInventoryTypeId(value.id);
                  setInventoryTypeName(value.name);
                }}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type='submit'
          form='inventory-form'
          className='save-modal-button'
        >
          {saveStr}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalULocation;
